import React, { Component } from "react";
import Header from "../components/header/header";
import Footer from "../components/statics/footer";
import Categories from "../components/category/categoryList";
import { connect } from "react-redux";
import * as CategoryProvider from "../providers/categoryProvider";
import { withRouter } from "react-router-dom";

class CategoryScreen extends Component {
  constructor(props) {
    super();
  }
  componentWillMount() {
    console.log("props category screen", this.props);
    //this.props.doGetCategories()
  }
  render() {
    return (
      <div>
        {/* <Header /> */}
        <Categories list={this.props.categories} history={this.props.history} />
        <Footer />
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doGetCategories: () => dispatch(CategoryProvider.getCategories())
  };
};
const mapStateToProps = state => {
  console.log("state home", state.category.list);
  return { categories: state.category.list };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CategoryScreen));
